/**
 * Constantes pour les informations SIRET et TVA d'Alertis
 * Shared between server and client — single source of truth
 */

// SIRET Alertis sans TVA (Alertis 1) : devis créés avant le 11/10/2026 pour professionnels avec TVA=Oui,
// financement≠OPCO, activité≠84.11Z ; ensuite, choix manuel dans l'éditeur du devis
export const ALERTIS_SIRET_SANS_TVA = '50988203100040';

// SIRET Alertis avec TVA (pour tous les autres cas)
export const ALERTIS_SIRET_AVEC_TVA = '93951657100014';

// Numéro de TVA d'Alertis
export const ALERTIS_TVA = 'FR64939516571';

// Code d'activité principale exceptionnel (Administration publique)
export const ACTIVITE_PRINCIPALE_EXCEPTION = '84.11Z';

// Constante de compatibilité (utilise le SIRET avec TVA par défaut)
export const ALERTIS_SIRET = ALERTIS_SIRET_AVEC_TVA;

// Nom d'entreprise Alertis 1 (sans TVA)
export const ALERTIS_1_COMPANY_NAME = 'ALERTIS CENTRE DE FORMATION SECURITE PREVENTION DES RISQUES PROFESSIONNELS';

// Nom d'entreprise Alertis 2 (avec TVA)
export const ALERTIS_2_COMPANY_NAME = 'ALERTIS FORMATION INCENDIE SST PSC AFGSU GESTE ET POSTURES HABILITATION ELECTRIQUE';

// Numéro de déclaration d'activité Alertis 1
export const ALERTIS_1_DECLARATION_NUMBER = '82691097869 (Rhône)';

// Numéro de déclaration d'activité Alertis 2
export const ALERTIS_2_DECLARATION_NUMBER = '84692410569';

// Coordonnées Alertis
export const ALERTIS_DEFAULT_CONTACT_NAME = 'TONG Elsa';
export const ALERTIS_DEFAULT_EMAIL = 'formationsante@alertis.fr';
export const ALERTIS_ADDRESS = '20 avenue des Frères Montgolfier, 69680 CHASSIEU';
export const ALERTIS_PHONE = '+33478904630';

// Label TVA Alertis 1 (exonération)
export const ALERTIS_1_TVA_LABEL = 'TVA non applicable (Prestations de formation en exonération de TVA, article 261-4-4a du CGI)';

// Label TVA Alertis 2 (20%)
export const ALERTIS_2_TVA_LABEL = 'TVA à 20%';

// Taux de TVA Alertis 2
export const ALERTIS_2_TVA_RATE = 0.20;

/**
 * En-tête du devis (le grand titre tout en haut du document), par société.
 * Il doit dire la MÊME société que le bloc Organisateur et le pied de page :
 * jusqu'au 22/09/2026 il était écrit en dur sur Alertis 1, quel que soit le
 * SIRET choisi, et un devis Alertis 2 s'ouvrait sur le nom d'Alertis 1.
 */
export const ALERTIS_1_HEADER = Object.freeze({
  companyName: 'ALERTIS CENTRE DE FORMATION',
  companySubtitle: 'SECURITE PREVENTION DES RISQUES PROFESSIONNELS',
});
export const ALERTIS_2_HEADER = Object.freeze({
  companyName: 'ALERTIS FORMATION',
  companySubtitle: 'INCENDIE SST PSC AFGSU GESTE ET POSTURES HABILITATION ELECTRIQUE',
});

/**
 * Retourne le taux de TVA pour une clé d'entité PDF (ALERTIS_ENTITIES).
 * Attention : le nommage PDF est inversé par rapport aux constantes :
 *   - PDF 'ALERTIS_1' = siret avec TVA (20%) = entité par défaut
 *   - PDF 'ALERTIS_2' = siret sans TVA (exonération)
 * @param {string} entityKey - 'ALERTIS_1' ou 'ALERTIS_2'
 * @returns {number} - Taux de TVA (0.20 ou 0)
 */
export function getTvaRateForEntity(entityKey) {
  return entityKey === 'ALERTIS_1' ? ALERTIS_2_TVA_RATE : 0;
}

/**
 * Calcule le montant TTC d'une inscription à partir du montant HT et de l'entité.
 * @param {number} montantHT - Montant hors taxes
 * @param {string} entityKey - 'ALERTIS_1' ou 'ALERTIS_2'
 * @returns {number} - Montant TTC
 */
export function calculateInscriptionTTC(montantHT, entityKey) {
  if (!montantHT) return montantHT || 0;
  const tvaRate = getTvaRateForEntity(entityKey);
  return montantHT * (1 + tvaRate);
}
